import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { take } from "rxjs/operators";
import { AppBLL } from "src/app/app.bll";
import { ApiService } from "src/app/services/api/api.service";
import { StorageService } from "src/app/services/azure/storage/storage.service";
import { ToastService } from "src/app/services/toast/toast.service";

@Injectable({
  providedIn: 'root',
})
export class ManageAdminsBLL {
  //#region Loaders Observables

  private isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  readonly isLoading$: Observable<boolean> = this.isLoading.asObservable();

  private isAddAdminModelOpen: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  readonly isAddAdminModelOpen$: Observable<boolean> =
    this.isAddAdminModelOpen.asObservable();

  private isUpdateAdminModelOpen: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  readonly isUpdateAdminModelOpen$: Observable<boolean> =
    this.isUpdateAdminModelOpen.asObservable();


  private contacts: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  readonly contacts$: Observable<any> = this.contacts.asObservable();


  private admin: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  readonly admin$: Observable<any> = this.admin.asObservable();



  private contact: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  readonly contact$: Observable<any> = this.contact.asObservable();

  private creation_status: BehaviorSubject<string> =
    new BehaviorSubject<string>(null);
  readonly creation_status$: Observable<string> =
    this.creation_status.asObservable();

  selectedContact$: Subject<any> = new Subject<any>();
  selectedAd$: Subject<any> = new Subject<any>();

  //#endregion Data Observables

  constructor(
    private api: ApiService,
    private toast: ToastService,
    private storage: StorageService,
    // private memberBLL: MembershipBLL,
    private appBll: AppBLL,
    private router: Router
  ) { }

  public getAdmins() {
    this.isLoading.next(true);

    let url = `field-events?type=get_all_admins`;

    this.api
      .get(url)
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          this.contacts.next(response);
          this.isLoading.next(false);
        },
        (err) => {
          this.isLoading.next(false);
        }
      );
  }

  public getAvailableAdmin(email: string) {
    this.isLoading.next(true);

    let url = `field-events?type=search_available_admin&search=${email}`;

    this.api
      .get(url)
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          this.admin.next(response);
          this.isLoading.next(false);
        },
        (err) => {
          console.log(err);
          if (err.status === 400) {
            this.toast.showToast('Not Found', 'The searched user is neither a coach nor a registrar.');
          }
          if (err.status === 409) {
            this.toast.showToast('Admin already exists', 'Admin already exists for this user. for this user.');
          }
          if (err.status === 404) {
            this.toast.showToast('Not Fount', 'No user found with this email.');
          }
          this.admin.next(null);

          this.isLoading.next(false);
        }
      );
  }

  public async createAdmin(contact) {
    this.isLoading.next(true);

    let url = `field-events?type=post_admin`;
    this.api
      .post(url, contact)
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          this.isLoading.next(false);
          this.creation_status.next('success');
          this.toast.showToast('Success!', 'Admin has been created.');
          this.toggleAddAdminModel(false);
          // this.selectedAd$.next(response?.data?.id);
          // this.appBll.get_subscriptions();
        },
        (err) => {
          this.isLoading.next(false);
        }
      );
  }


  public async deleteAdmin(id: string, sub_admin_email: string = null) {
    let url = `field-events?type=delete_admin&id=${id}&sub_admin_email=${sub_admin_email}`;
    this.api.delete(url).subscribe(
      async () => {
        this.getAdmins();
        this.toast.showToast('Success!', 'Admin has been deleted.');
      },
      async (err) => {
        console.log('HTTP Error', err);
      }
    );
  }

  public async editAdmin(id, contact) {
    let url = `field-events?type=update_ad_contact`;
    this.isLoading.next(true);

    let update_contact = { ...contact, id: id };

    this.api
      .patch(url, update_contact)
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          this.isLoading.next(false);
          this.toast.showToast('Success!', 'Contact has been updated.');
          this.creation_status.next('success');
        },
        (err) => {
          this.isLoading.next(false);
        }
      );
  }

  toggleAddAdminModel(isOpen: boolean) {
    this.isAddAdminModelOpen.next(isOpen);
  }

  changeUpdateAdminModelOpen(isOpen: boolean) {
    this.isUpdateAdminModelOpen.next(isOpen);
  }

}
